import {initializeApp} from 'firebase/app';
import {getStorage} from 'firebase/storage';
import {getFirestore} from 'firebase/firestore';
import {
  initializeAuth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
} from "firebase/auth";


const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC-LG7giXKWPqjbgiAEK3udPlws1W3WS2A",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "alphamizer-451802-recovery.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "alphamizer-451802-recovery",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "alphamizer-451802-recovery.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "816071275963",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:816071275963:web:7f4a552ae4adb7af61c09e"
};

const app = initializeApp(firebaseConfig);
const isDev = import.meta.env.DEV;
const appVerificationDisabledForTesting =
  import.meta.env.VITE_FIREBASE_AUTH_DISABLE_APP_VERIFICATION === 'true';

const persistence = browserLocalPersistence;

const auth = initializeAuth(app, {
  persistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

// Keep Firebase phone auth usable in local development unless testing is explicitly enabled.
auth.settings = { appVerificationDisabledForTesting };

console.log("Firebase Auth initialized.", {
  isDev,
  appVerificationDisabledForTesting: auth.settings.appVerificationDisabledForTesting
});

const storage = getStorage(app);

// Firestore is used as a small side-store for live per-user state
// (see NEWS_FEED_LIVING_SPEC.md W8 — read-state markers with TTL).
// Access is gated by `firestore.rules` (per-user paths, deny-by-default).
const firestore = getFirestore(app);

export { app, auth, storage, firestore };
